import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    FailureNotification,
    OptionItem,
    PaginateResponse,
    Response,
} from 'app/modules/corrective-maintenance/model';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { Observable, take } from 'rxjs';
import { getFormattedDateTime } from 'app/core/shared/helper/date.helper';

@Injectable({ providedIn: 'root' })
export class FailureNotificationService {
    constructor(private _httpClient: HttpClient) { }

    getWellString(search: any = {}) {
        search.hasProductionStatus = true;
        const url = composeUrl('/v1/WellHeaderInformation/FilterData', search);
        return this._httpClient.get<Response<PaginateResponse<any>>>(url);
    }

    getFailureNotification(
        params: any
    ): Observable<Response<PaginateResponse<FailureNotification>>> {
        const url = composeUrl(
            `/v1/CorrectiveMaintenance/GetFailureNotificationList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<FailureNotification>>>(url)
            .pipe(take(1));
    }

    getFailureNotificationById(
        id: any
    ): Observable<Response<FailureNotification>> {
        const url = composeUrl(
            `/v1/CorrectiveMaintenance/GetFailureNotificationById/${id}`
        );
        return this._httpClient
            .get<Response<FailureNotification>>(url)
            .pipe(take(1));
    }

    save(payload: any): Observable<any> {
        const url = composeUrl(
            `/v1/CorrectiveMaintenance/CreateUpdateFailureNotification`
        );
        return this._httpClient.post<any>(url, payload).pipe(take(1));
    }

    downloadExcel() {
        const { date, time } = getFormattedDateTime();
        const url = composeUrl(
            `/v1/CorrectiveMaintenance/DownloadOverallFnExcel`
        );
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `CM_Failure_Notification_${date}_${time}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }

    getValveOptionType(): Observable<Response<OptionItem[]>> {
        const url = composeUrl(
            `/v1/Option/GetOptionItems?mdOptionName=md_cm_equipment`
        );
        return this._httpClient.get<Response<OptionItem[]>>(url).pipe(take(1));
    }

    deleteFailureNotification(failureNotificationId: string): Observable<Response<any>> {
        const url = composeUrl(`/v1/CorrectiveMaintenance/DeleteFailureNotification/${failureNotificationId}`);
        return this._httpClient.delete<any>(url);
    }
}
